import React from 'react';
import { TopRolesWithCount } from 'server/models/Replay2023';

export interface Slide3Props {
  topRoles: TopRolesWithCount[];
}

/** Slide 3 - Top Roles with count */
export const Slide03 = ({
  topRoles,
}: Slide3Props) => (
  <div className="absolute inset-0 w-full h-full text-yellow text-center left-1/2 -translate-x-1/2 items-center flex flex-col justify-center">
    <div className="text-2xl font-light mb-6 absolute top-[15%]">In 2025, you were credited</div>
    <div className="pt-20">
      {topRoles.map((role) => (
        <div className="mb-14" key={role.name}>
          <div className="font-extrabold text-7xl animate-flyleft">
            {role.count}
            <span className="font-light text-3xl">x</span>
          </div>
          <div className="text-3xl font-bold uppercase animate-flyright">
            {role.name}
          </div>
        </div>
      ))}
    </div>
  </div>
);
